// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';
import Lottie from 'lottie-react';
import animationData from '../assets/404-animation.json'; // adjust path if needed

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50 p-4 animate-fade-in">
      <div className="max-w-2xl w-full text-center">

        {/* Large Lottie with floating animation */}
        <div className="w-full max-w-lg mx-auto animate-float">
          <Lottie animationData={animationData} loop={true} />
        </div>

        {/* Smooth, minimalist button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 text-primary-600 hover:text-primary-700 border border-primary-200 hover:border-primary-300 rounded-full transition-all duration-200 ease-in-out hover:bg-primary-50/50 hover:shadow-sm hover:-translate-y-0.5"
        >
          <HomeIcon className="w-5 h-5" />
          <span className="font-medium">Go Home</span>
        </Link>
      </div>

      {/* Custom CSS for smooth animations */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: scale(0.95); }
          to   { opacity: 1; transform: scale(1); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50%      { transform: translateY(-12px); }
        }
        .animate-fade-in {
          animation: fade-in 0.7s ease-out forwards;
        }
        .animate-float {
          animation: float 3.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default NotFound;